export default __webpack_public_path__ + "static/emaibg-076a84276c62ea3351b3f648374fcee4.jpg";